import stationerImg from '../../assets/images/home/stationer.png';
import toysImg from '../../assets/images/home/toys.png';
import stainlessImg from '../../assets/images/home/stainless.png';
import handbagsImg from '../../assets/images/home/handbags.png';
import giftImg from '../../assets/images/home/gift.png';
import plasticImg from '../../assets/images/home/plastic.png';
import cosmeticsImg from '../../assets/images/home/cosmetics.png';
import sportsImg from '../../assets/images/home/sports.png';
import fashionsImg from '../../assets/images/home/fashions.png';
import ceramicImg from '../../assets/images/home/ceramic.png';

const Categories = () => {
  const categories = [
    { name: 'STATIONER', image: stationerImg },
    { name: 'TOYS', image: toysImg },
    { name: 'STAINLESS STEEL UTENSILS', image: stainlessImg },
    { name: 'HAND BAGS', image: handbagsImg },
    { name: 'GIFT ARTICLES', image: giftImg },
    { name: 'PLASTIC', image: plasticImg },
    { name: 'COSMETICS', image: cosmeticsImg },
    { name: 'SPORTS ITEMS', image: sportsImg },
    { name: 'FASHION ACCESSORIES', image: fashionsImg },
    { name: 'CERAMIC ITEMS', image: ceramicImg },
  ];

  return (
    <section className="py-12 bg-gray-200">
      <div className="container mx-auto px-7 ">
        <h2 className="text-3xl font-bold text-center mb-12">YOUR ONE STOP for all your DAILY NEEDS</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-12">
          {categories.slice(0, 5).map((category, index) => (
            <div key={index} className="cursor-pointer hover:opacity-90 transition-opacity">
              <img 
                src={category.image} 
                alt={category.name} 
                className="w-full h-auto"
              />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-4">
          {categories.slice(5).map((category, index) => (
            <div key={index} className="cursor-pointer hover:opacity-90 transition-opacity">
              <img 
                src={category.image} 
                alt={category.name} 
                className="w-full h-auto"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;